// extracted by mini-css-extract-plugin
module.exports = {"grid":"grouping_grid___p0Ms","table":"grouping_table__3wKtL","noData":"grouping_noData__1xFfn","labelBLock":"grouping_labelBLock__1SRv8","right":"grouping_right__1ixBC"};